var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-name"},[_c('b-field',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],class:['curved-border is-size-5 is-heavy p-2', _vm.adminAnswer ? 'read-only' : ''],style:({
        backgroundColor: _vm.$root.$data.COLORS.neutral[3],
        borderColor: 'transparent',
        resize: 'none',
        width: '100%',
        minHeight: '200px',
        height: _vm.height ? _vm.height : 'auto',
      }),attrs:{"placeholder":_vm.placeholder ? _vm.placeholder : 'Answer here',"readonly":!_vm.isEditable},domProps:{"value":(_vm.answer)},on:{"input":[function($event){if($event.target.composing)return;_vm.answer=$event.target.value},function($event){return _vm.$emit('answered', _vm.answer)}]}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }